module.exports = __webpack_public_path__ + "static/Depositphotos_26671801_m-2015-81fde36f89113eb0d75ddc805e87d3f0.jpg";